import {ValueError} from '../../../../common/timecard.model';
import {Split} from '../../../../common/split-coding.model';
import {Note} from '../../../../common/timecard-note.model';
import {AccountCode, AccountCoding, CrewDetail, SagDetail, ShiftDate, ShiftRate, UkPunch, UsaPunch, WorkStatus} from '../../../../common/timecard.shifts.model';
import {SummaryAccountCode, SummaryBasics, SummaryDate, SummaryJobDetail, SummaryPayDetail} from '../../../../common/timecard.summary-items.model';
import {IUkSummaryPayDetail, ShiftUnit, UkCrewWorkDetail} from '../../../../common/timecard-models/uk.model';
import {ISummaryDate, ISummaryDetail, ISummaryJobDetail} from '../../../../common/timecard-models/common.model';

export interface GridValueUpdate {
  shiftId: string;
  [fieldName: string]: string|number|boolean|ValueError<string>|ValueError<number>;
}
export interface SummaryGridValueUpdate {
  summaryId: string;
  [fieldName: string]: string|number|ValueError<string>|ValueError<number|null>;
}

export interface AccountCodeValueUpdate {
  shiftId: string;
  segmentIndex: number;
  value: ValueError<string>;
}

export interface GlshortcutValueUpdate {
  shiftId: string;
  accountCode: AccountCode;
}

export interface AccountSplitUpdate {
  shiftId: string;
  splits: Split[];
}

export interface SummaryAccountCodeValueUpdate {
  summaryId: string;
  segmentIndex: number;
  value: ValueError<string>;
}

export interface Clipboard {
  shift?: Shift;
  summaryLine?: SummaryLine;
}

export interface UkClipboard {
  shift?: ShiftUk;
  summaryLine?: SummaryLineUk;
}

export interface ShiftUpdate {
  shiftId: string;
  shift: Shift;
}

export interface UkShiftUpdate {
  shiftId: string;
  shift: ShiftUk;
}

export interface SummaryLineUpdate {
  summaryId: string;
  summaryLine: SummaryLine;
}

export interface UkSummaryLineUpdate {
  summaryId: string;
  summaryLine: SummaryLineUk;
}

export interface Shift {
  shiftId: string;
  shiftDate?: ShiftDate;
  shiftRate?: ShiftRate;
  workDetail?: CrewDetail|SagDetail;
  accountCode?: AccountCoding;
  payPunch?: UsaPunch;
  prPunch?: UsaPunch;
  mobilePunch?: UsaPunch;
  workStatus?: WorkStatus;
}

export interface ShiftUk {
  shiftId: string;
  shiftDate?: ShiftDate;
  shiftRate?: ShiftRate;
  workDetail?: UkCrewWorkDetail;
  accountCode?: AccountCoding;
  punch?: UkPunch;
  shiftUnit?: ShiftUnit;
}

export interface SummaryLine {
  summaryId: string;
  date?: SummaryDate;
  basics?: SummaryBasics;
  accountCode?: SummaryAccountCode;
  jobDetail?: SummaryJobDetail;
  payDetail?: SummaryPayDetail;
}

export interface SummaryLineUk {
  summaryId: string;
  accountCodes?: SummaryAccountCode;
  basics?: ISummaryDetail;
  dates?: ISummaryDate;
  jobDetails?: ISummaryJobDetail;
  payDetails?: IUkSummaryPayDetail;
}
export interface WorkDetailLocation {
  countryCode: string;
  stateCode: string;
  countyCode: string;
  cityCode: string;
}

export enum TCQuickActionResponse {
  Copy = 1,
  Paste = 2,
  Clear = 3
}

export enum PunchType {
  DailyTimePunches = 'Daily Time Punches',
  MobileTimePunches = 'Mobile Time Punches'
}

export enum PunchTab {
  Pay_Times = 'PAY TIMES',
  Daily_Times = 'DAILY TIMES',
  Mobile_Times = 'MOBILE TIMES'
}

export enum PunchTabUk {
  Pay_Times = 'PAY TIMES',
  Mobile_Times = 'MOBILE TIMES'
}

export interface TcSummary {
  batchName: string;
  status: string;
  isSubmitted: boolean;
}

export interface WorkLocationUpdate {
  [fieldName: string]: string|ValueError<string>;
}

export interface AutoApplyTimecardTemplate {
  templateName: string;
  isAutoApply: boolean;
}

export interface TimecardNote {
  count: number;
  latestNotes: string;
  allNotes: Note[];
}

export interface Discrepancy {
  punch: UsaPunch;
  workDetail: CrewDetail;
  date: string;
  splitShiftOrdinal?: number;
}

export interface DiscrepancyViewModel {
  [shiftDate: string]: Discrepancy[];
}
